import { fetchTagsForFilter, fetchUsersForFilter } from 'actions';
import DropdownFilter from 'components/Filters/DropdownFilter/DropdownFilter';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import React from 'react';
import { getFetchAllTagsLoading, getTagsForFilters } from 'selectors/tags';
import { getUsersList, getUsersLoading } from 'selectors/users';

const ReviewSetsFilters: React.FC = () => (
  <div className="flex flex-row gap-2">
    <div className="w-1/2">
      <DropdownFilter
        resource={resourceQueryParamName.savedSearch}
        fetchAction={fetchTagsForFilter}
        filterKey="tag_uuids"
        itemField="uuid"
        getResourceList={getTagsForFilters}
        getLoading={getFetchAllTagsLoading}
        title="Tags"
        nameKey="value"
        notFoundText="No tags found"
      />
    </div>
    <div className="w-1/2">
      <DropdownFilter
        resource={resourceQueryParamName.savedSearch}
        fetchAction={fetchUsersForFilter}
        fetchParams={{ roles: ['reviewer', 'super-reviewer', 'legal-user'] }}
        filterKey="user_uuids"
        itemField="uuid"
        getResourceList={getUsersList}
        getLoading={getUsersLoading}
        title="Reviewers"
        nameKey="name"
        notFoundText="No reviewers found"
      />
    </div>
  </div>
);

export default ReviewSetsFilters;
